import type { HydraGetSubscriptionItem } from '@/lib/services/Hydra/account/GET/getSubscriptions'

export const getSubcriptionEditUrl = (
  subscriptionItem: HydraGetSubscriptionItem,
) =>
  subscriptionItem.href.includes('/autoorders/')
    ? `/autoorders/${subscriptionItem.href.split('/autoorders/')[1]}`
    : ''
